import { action, makeObservable } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { CarrierServiceService } from 'common/data';

class CarrierServiceStore extends BaseStore {
	constructor(rootStore) {
		super(new CarrierServiceService(rootStore.app.baasic.apiClient));
		makeObservable(this);
	}

	@action async findCarrierService(filter) {
		const response = await this.service.find(filter);
		if (filter) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}
}

export default CarrierServiceStore;
